import { render } from "./InvoicesForm.vue?vue&type=template&id=52218146&scoped=true"
import script from "./InvoicesForm.vue?vue&type=script&lang=js"
export * from "./InvoicesForm.vue?vue&type=script&lang=js"

import "./InvoicesForm.vue?vue&type=style&index=0&id=52218146&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52218146"]])

export default __exports__